import {showToast} from "../components/general/CustomToast";

export function reemplaceValue(type: string | undefined, value: string, maxLength: number | undefined) {
    let filteredValue;
    if (!type) {
        return value;
    }
    switch (type) {
        case 'identification' :
            filteredValue = value.replace(/\D/g, '').slice(0, 10);
            return filteredValue;
        case 'telephone' :
            filteredValue = value.replace(/\D/g, '').slice(0, maxLength ? maxLength : 500);
            return filteredValue;
        case 'integer' :
            filteredValue = value.replace(/[^-\d]/g, '').slice(0, maxLength ? maxLength : 500);
            return filteredValue;
        case 'number' :
            filteredValue = value.replace(/[^\d.]/g, '');
            return filteredValue;
        case 'mail' :
            filteredValue = value.replace(/[!"#$%&/()=?¡'*{}[\],><+`^~|°¿;]/g, '');
            return filteredValue;
        case 'letters' :
            filteredValue = value.replace(/[!"#$%&/()=?¡'*{}[\],@_\-><`^~.:+°|¿;0-9]/g, '');
            return filteredValue;
        case 'text' :
            filteredValue = value.replace(/["#$&/()*{}[\]@\-><`^~+°|]/g, '');
            return filteredValue;
        default :
            return value;
    }
}

/**
 * Función `getBooleanByParameter`:
 *
 * Esta función convierte un string a un booleano. Si el valor es nulo o indefinido, se muestra un mensaje de error.
 *
 * @param value - El valor de entrada que se desea evaluar.
 * @param hiddenAlert - ocular alerta de variable de entorno.
 *
 * @returns `true` si el valor es 'true', `false` en caso contrario, o un string vacío si hay un error.
 */
export function getBooleanByParameter(value?: string, hiddenAlert?: boolean) {
    if(!value) {
        if (!hiddenAlert) {
            showToast('Error en configuración de parámetro', undefined, 'error');
        }
        return false
    }
    return value.toLowerCase() === 'true'
}

/**
 * Función `validEmptyText`:
 *
 * Esta función retorna el valor en string.
 *
 * @param value - El valor de entrada.
 *
 * @returns string.
 */
export function validEmptyText(value: string | undefined | null): string {
    if (!value) {
        return '';
    }
    return value;
}
